
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Line Length`}</h1>
<p>{`Always favor writing lines shorter than 80 characters. Never write lines longer than 100 characters.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
process.env.NODE_ENV === 'development' ? console.error(new Error(\`Browser doesn't support Geolocation\`)) : null;

// Good
process.env.NODE_ENV === 'development' 
  ? console.error(new Error('Browser doesn\\'t support Geolocation')) 
  : null;
`}</code></pre>
<p>{`Never split lines too early.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? It's easier to read single line statements than multi-line ones.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo(
  bar,
  baz,
) {
  return bar + baz;
}

// Good
function foo(bar, baz) {
  return bar + baz;
}
`}</code></pre>
<p>{`When spliting long arrays of objets, always put the braces in a separate line.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? Easier to add, remove, modify, copy/paste, etc. since each object is isolated.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
const people = [{
  name: 'John',
  age: 23,
}, {
  name: 'Jane',
  age: 26,
}];

const people = [
  {
    name: 'John',
    age: 23,
  }, {
    name: 'Jane',
    age: 26,
  },
];

// Good
const people = [
  {
    name: 'John',
    age: 23,
  },
  {
    name: 'Jane',
    age: 26,
  },
];

// Also good
const people = [
  { name: 'John', age: 23 },
  { name: 'Jane', age: 26 },
];
`}</code></pre>
<p>{`When splitting long lines, always position the operator at the beginning of the line.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? To differentiate it from a new statement.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
const shouldWe = reasonOne &&
  reasonTwo &&
  reasonThree;

const bigOp = foo +
  bar +
  baz;

// Good
const shouldWe = reasonOne
  && reasonTwo
  && reasonThree;

const bigOp = foo
  + bar
  + baz;
`}</code></pre>
<h5><strong parentName="h5">{`NOTE`}</strong>{`: Don't forget to indent splitted lines correctly.`}</h5>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;